import { isPromoCodeAppliedToAnyRate } from '../selectors/request'
import {
  CLEAR_PROMO_CODE,
  FETCH_AVAILABILITY_COMPLETED,
  FETCH_AVAILABILITY_FAILED,
  SET_PROMO_CODE,
  ON_OCCUPANCY_CHANGE,
  SET_REQUEST,
  SET_REFERENCE_CODE,
  SET_FROM_GOOGLE_TRAVEL
} from 'Rentlio/state/types'
import createReducer from 'Rentlio/state/utils/createReducer'
import { hasUnselectedChildAge } from 'Rentlio/utils/childrenAges'

/**
const initialState = {
  from: int,
  to: int,
  adults: int,
  children: int[],
  rooms: int,
  promoCode: null|string,
  referenceCode: null|string,
  fromGoogleTravel: bool
}
**/

const initialState = {
  from: null,
  to: null,
  adults: null,
  children: [],
  rooms: null,
  promoCode: null,
  promoCodeError: null,
  isPromoCodeAppliedToAnyRate: false,
  unitTypeId: null,
  ratePlanId: null,
  bookingEngineId: null,
  referenceCode: null,
  fromGoogleTravel: false
}

const request = createReducer(initialState)({
  [FETCH_AVAILABILITY_COMPLETED]: (state, action) => ({
    ...action.payload.request,
    children: hasUnselectedChildAge(state.children) ? state.children : action.payload.request.children,
    isPromoCodeAppliedToAnyRate: isPromoCodeAppliedToAnyRate(action.payload?.unitTypes),
    referenceCode: state.referenceCode,
    fromGoogleTravel: state.fromGoogleTravel
  }),
  [FETCH_AVAILABILITY_FAILED]: (state, action) => {
    if (
      action.payload?.response[0]?.message &&
      (action.payload?.response[0]?.message === 'Promo code is invalid' ||
        action.payload?.response[0]?.message === 'Provide a promo code')
    ) {
      return { ...state, promoCodeError: true, isPromoCodeAppliedToAnyRate: false }
    }
    return { ...state }
  },
  [SET_PROMO_CODE]: (state, { promoCode }) => ({
    ...state,
    promoCode,
    promoCodeError: null,
    isPromoCodeAppliedToAnyRate: false
  }),
  [CLEAR_PROMO_CODE]: (state, _) => ({
    ...state,
    promoCode: null,
    promoCodeError: null,
    isPromoCodeAppliedToAnyRate: false
  }),
  [ON_OCCUPANCY_CHANGE]: (state, action) => ({ ...state, adults: action.adults, children: action.children }),
  [SET_REQUEST]: (_, { payload }) => payload,
  [SET_REFERENCE_CODE]: (state, action) => ({ ...state, referenceCode: action.referenceCode }),
  [SET_FROM_GOOGLE_TRAVEL]: (state, action) => ({ ...state, fromGoogleTravel: action.fromGoogleTravel })
})

export default request

export function getSearchRequest(state) {
  return state.request
}
